// apps/dashboard/src/routes/sign-up.tsx
import { createFileRoute, redirect } from "@tanstack/react-router";
import { SignUp } from "@clerk/react";
import { AuthShell } from "@/components/chrome/AuthShell";
import {
  SELECTED_TIER_SEARCH_SCHEMA,
  selectedTierRedirectUrl,
} from "@/lib/selectedTier";

export const Route = createFileRoute("/sign-up")({
  staticData: { shell: "auth" },
  // Visitors arrive here from a website pricing CTA carrying ?plan & ?interval.
  // Validate the params so they can be forwarded onto the post-signup redirect
  // URL — Clerk's <SignUp> preserves forceRedirectUrl across its multi-step
  // flow, the only channel that survives account creation.
  validateSearch: SELECTED_TIER_SEARCH_SCHEMA,
  beforeLoad: () => {
    const clerk = (globalThis as {
      Clerk?: { user?: unknown; session?: { status?: string } };
    }).Clerk;
    if (clerk?.user && clerk.session?.status !== "pending") {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: SignUpPage,
});

function SignUpPage() {
  const { plan, interval } = Route.useSearch();
  return (
    <AuthShell>
      <SignUp
        routing="hash"
        forceRedirectUrl={selectedTierRedirectUrl(plan, interval)}
        signInUrl="/sign-in"
      />
    </AuthShell>
  );
}
